import React, { useEffect, useState } from "react";
import Datatable from "../../datatable/Datatable";
import Navbar from "../navbar/navbar";
import { getPaymentTransactionList } from "../../services/admin.service";
import Swal from "sweetalert2";
import { format } from "date-fns";
import "../admin/adminModule.css";

const PaymentTransactionListComponent = () => {
  const [transactionList, setTransactionList] = useState([]);

  useEffect(() => {
    fetchTransactionList();
  }, []);

  const fetchTransactionList = async () => {
    try {
      const data = await getPaymentTransactionList();
      setTransactionList(data || []);
    } catch (error) {
      console.error("Failed to fetch payment transaction list", error);
      Swal.fire("Error", "Failed to load payment transactions", "error");
    }
  };

  const formatTimestamp = (dateVal) => {
    if (!dateVal) return "-";
    try {
      const date = new Date(dateVal);
      if (isNaN(date.getTime())) return "-";
      return format(date, "dd-MM-yyyy hh:mm a");
    } catch (e) {
      return "-";
    }
  };

  const formatAmount = (val) => {
    if (val === null || val === undefined) return "₹0.00";
    try {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
      }).format(Number(val));
    } catch (e) {
      return `₹${val}`;
    }
  };

  const renderStatusBadge = (status) => {
    const s = String(status || "").toLowerCase();
    let bg = "bg-secondary";
    if (s === "captured" || s === "success" || s === "paid") {
      bg = "bg-success";
    } else if (s === "failed" || s === "error") {
      bg = "bg-danger";
    } else if (s === "authorized" || s === "pending") {
      bg = "bg-warning text-dark";
    }

    return (
      <span
        className={`badge ${bg}`}
        style={{ fontSize: "12px", padding: "5px 10px", borderRadius: "12px" }}
      >
        {status ? String(status).toUpperCase() : "UNKNOWN"}
      </span>
    );
  };

  const renderMethodBadge = (method) => {
    if (!method) return "-";
    const m = String(method).toUpperCase();
    return (
      <span
        className="badge bg-light text-dark border"
        style={{ fontSize: "11px", padding: "4px 8px" }}
      >
        {m}
      </span>
    );
  };

  const columns = [
    { name: "SN", selector: (row) => row.sn, sortable: true, align: "text-center", width: "60px" },
    { name: "Date & Time", selector: (row) => row.transactionDate, sortable: true, align: "text-start", width: "170px" },
    { name: "Razorpay ID", selector: (row) => row.razorpayId, sortable: true, align: "text-start", width: "190px" },
    { name: "Devotee Name", selector: (row) => row.name, sortable: true, align: "text-start", width: "160px" },
    { name: "Mobile No", selector: (row) => row.mobileNumber, sortable: true, align: "text-start", width: "130px" },
    { name: "Amount", selector: (row) => row.amount, sortable: true, align: "text-end", width: "110px" },
    { name: "Method", selector: (row) => row.method, sortable: true, align: "text-center", width: "110px" },
    { name: "Status", selector: (row) => row.status, sortable: true, align: "text-center", width: "110px" },
    { name: "Error / Notes", selector: (row) => row.errorDetails, sortable: false, align: "text-start", width: "240px" },
  ];

  const mappedData = () => {
    return transactionList.map((item, index) => ({
      sn: index + 1,
      transactionDate: formatTimestamp(item.transactionDate),
      razorpayId: (
        <span className="font-monospace small fw-bold text-primary">
          {item.razorpayId || "-"}
        </span>
      ),
      name: item.name || "-",
      mobileNumber: item.mobileNumber || "-",
      amount: <strong className="text-dark">{formatAmount(item.amount)}</strong>,
      method: renderMethodBadge(item.method),
      status: renderStatusBadge(item.status),
      errorDetails: (item.errorDescription || item.errorCode) ? (
        <span
          className="text-muted text-break"
          title={item.errorDescription || item.errorCode}
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            maxWidth: "230px",
            fontSize: "12px",
            lineHeight: "1.3"
          }}
        >
          {item.errorDescription || item.errorCode}
        </span>
      ) : "-",
    }));
  };

  return (
    <div className="card">
      <Navbar />
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-md-12 text-center">
            <h3 className="admin-custom-heading">
              Payment Transaction List
            </h3>
          </div>
        </div>
      </div>
      <div id="card-body customized-card" className="p-2">
        <Datatable columns={columns} data={mappedData()} />
      </div>
    </div>
  );
};

export default PaymentTransactionListComponent;
